import { getCookie } from "@/utils/cookie";
const lang = getCookie("language");

const usedLanguage = lang.includes("es") ? "es" : "pt";

const translations = require(`./${usedLanguage}`).default;

export default function customTranslate(template: any, replacements: any) {
  replacements = replacements || {};

  // Translate
  template = translations[template] || template;

  // Replace
  return template.replace(/{([^}]+)}/g, (_: any, key: any) => {
    return replacements[key] || "{" + key + "}";
  });
}
